import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M12.85 17.85L11.15 19.55C11.06 19.65 10.93 19.69 10.8 19.69C10.67 19.69 10.54 19.65 10.45 19.55C10.25 19.35 10.25 19.04 10.45 18.84L11.3 17.99H6.5C6.22 17.99 6 17.77 6 17.49V11.5C6 11.22 6.22 11 6.5 11C6.78 11 7 11.22 7 11.5V16.99H11.29L10.45 16.15C10.25 15.95 10.25 15.64 10.45 15.44C10.64 15.25 10.96 15.25 11.15 15.44L12.78 17.08C12.8 17.09 12.83 17.12 12.85 17.14C13.05 17.34 13.05 17.65 12.85 17.85V17.85Z"
      fill="currentColor"
    />
    <path
      d="M8.49609 10H4.49609C3.66909 10 2.99609 9.327 2.99609 8.5V4.5C2.99609 3.673 3.66909 3 4.49609 3H8.49609C9.32309 3 9.99609 3.673 9.99609 4.5V8.5C9.99609 9.327 9.32309 10 8.49609 10ZM4.49609 4C4.22009 4 3.99609 4.224 3.99609 4.5V8.5C3.99609 8.776 4.22009 9 4.49609 9H8.49609C8.77209 9 8.99609 8.776 8.99609 8.5V4.5C8.99609 4.224 8.77209 4 8.49609 4H4.49609V4Z"
      fill="currentColor"
    />
    <path
      d="M19.4961 21H15.4961C14.6691 21 13.9961 20.327 13.9961 19.5V15.5C13.9961 14.673 14.6691 14 15.4961 14H19.4961C20.3231 14 20.9961 14.673 20.9961 15.5V19.5C20.9961 20.327 20.3231 21 19.4961 21ZM15.4961 15C15.2211 15 14.9961 15.225 14.9961 15.5V19.5C14.9961 19.775 15.2211 20 15.4961 20H19.4961C19.7711 20 19.9961 19.775 19.9961 19.5V15.5C19.9961 15.225 19.7711 15 19.4961 15H15.4961V15Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'ChildOutline');

export default Icon;
